import React from 'react';
import ExamCountdown from '../components/ExamCountdown';
import Footer from '../components/Footer';
import { Link } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';

const CountdownPage = () => {
    return (
        <div className="countdown-page">
            <div className="container pt-4">
                <Link to="/" className="back-link" style={{ marginTop: '20px', display: 'inline-flex' }}>
                    <FaArrowLeft /> Ana Sayfaya Dön
                </Link>
            </div>
            <ExamCountdown />
            <Footer />
        </div>
    );
};

export default CountdownPage;
